import { type ReactNode, type ReactElement } from 'react'
import { Size } from '@front/model'

type TDrawerBottomActionsProps = {
  children: ReactNode
}

export const TDrawerBottomActions = ({ children }: TDrawerBottomActionsProps): ReactElement => (
  <div
    style={{
      paddingTop: Size.space['4xl'],
      paddingBottom: Size.space['4xl'],
      position: 'sticky',
      bottom: 0,
      background: 'var(--mantine-color-body)',
      zIndex: 10,
    }}
  >
    {children}
  </div>
)
